import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FeaturesFooter from '../components/FeaturesFooter';
import TeamPart from '../components/TeamPart';

const Teams = () => {
  return (
    <div className="body teams-page">
      <Header /> 
      <div className="section is--hero teams-hero-section" >
        <div className="container-2 is--full" >
          <div className="hero">
            <div className="hero__item is--text is--home">
              <div className="hero__content">
                <h1 className="h1 teams-hero-title" style={{ display: 'inline-table', fontSize: '42px', fontWeight: 'bold', lineHeight: 1.25, letterSpacing: 'normal' }}>
                  <span style={{ fontSize: 'inherit', textTransform: 'uppercase' }}>E</span>
                  <span style={{ fontSize: '32px', textTransform: 'uppercase' }}>worxs</span> for Teams
                </h1>
                <div className="text-l">
                  <span className="line-break" style={{ fontSize: '16px', fontWeight: 'normal', lineHeight: 1.38 }}>
                    Automatically manage your field workers and automatically send invoices. Field worker management incorporates mileage and hour tracking, document capturing and much more. Eworxs is a user friendly and versatile app for Specialty Pharmacies, Infusion Nurses and the Home health industry!
                  </span>
                </div>
                <div className="hero__cta">
                  <a
                    href="#pricing"
                    className="button is--indigo w-inline-block teams-hero-button"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '10px',
                      padding: '14px 28px',
                      background: 'linear-gradient(90deg, #4e0159 0%, #741d81 100%)',
                      color: '#fff',
                      borderRadius: '10px',
                      fontWeight: 700,
                      fontSize: '18px',
                      boxShadow: '0 6px 18px rgba(74,144,226,0.15)',
                      border: 'none',
                      transition: 'all 0.3s',
                      letterSpacing: '0.5px',
                      textDecoration: 'none',
                      marginTop: '16px',
                    }}
                    onMouseOver={e => e.currentTarget.style.background = 'linear-gradient(90deg, #357abd 0%, #4a90e2 100%)'}
                    onMouseOut={e => e.currentTarget.style.background = 'linear-gradient(90deg, #4a90e2 0%, #357abd 100%)'}
                  >
                    <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '4px'}}>
                      <circle cx="11" cy="11" r="11" fill="#fff" fillOpacity="0.15"/>
                      <path d="M7 11.5l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <div>Get started</div>
                  </a>
                </div>
              </div>
            </div>
            <div className="hero__item is--home-image"></div>
          </div>
        </div>
      </div>
     
      <div className="section is--features">
        <div id="features" className="anchor-point"></div>
        <div className="container-2">
          <h4 className="h4-2 is--indigo is--mobile">Features</h4>
          <div className="features">
            <div className="features__item">
              <div className="features__item-bg is--blue"></div>
              <div className="features__image-container">
                <img src="img/banner2.png" loading="lazy" sizes="(max-width: 767px) 45vw, (max-width: 991px) 26vw, (max-width: 1439px) 22vw, (max-width: 1919px) 19vw, 319.4375px" srcSet="img/banner2-500.png 500w, img/banner2-800.png 800w, img/banner2-1080.png 1080w, img/banner2.png 1212w" alt="" className="features__image" />
              </div>
            </div>
            <div className="features__item is--text">
              <h4 className="h4-2 is--home-features is--indigo"></h4>
              <div className="features__title">
                <h2 className="h2-2" style={{ fontSize: '38px' }}>Teams</h2>
                <div className="plan-badge is--pro">
                  <div>Premium</div>
                </div>
              </div>
              <div className="features-list">
                <div className="feature-item"><img src="img/checkbox.svg" loading="lazy" alt="" className="feature-checkbox" /><div className="text-l is--dimmed">Create a team for free</div></div>
                <div className="feature-item"><img src="img/checkbox.svg" loading="lazy" alt="" className="feature-checkbox" /><div className="text-l is--dimmed">Unlimited trips</div></div>
                <div className="feature-item"><img src="img/checkbox.svg" loading="lazy" alt="" className="feature-checkbox" /><div className="text-l is--dimmed">Super Administrator dashboard</div></div>
                <div className="feature-item"><img src="img/checkbox.svg" loading="lazy" alt="" className="feature-checkbox" /><div className="text-l is--dimmed">Add and remove workers</div></div>
                <div className="feature-item"><img src="img/checkbox.svg" loading="lazy" alt="" className="feature-checkbox" /><div className="text-l is--dimmed">Add and remove clients</div></div>
                <div className="feature-item"><img src="img/checkbox.svg" loading="lazy" alt="" className="feature-checkbox" /><div className="text-l is--dimmed">IRS-compliant Data report</div></div>
                <div className="feature-item"><img src="img/checkbox.svg" loading="lazy" alt="" className="feature-checkbox" /><div className="text-l is--dimmed">Custom rates</div></div>
                <div className="feature-item"><img src="img/checkbox.svg" loading="lazy" alt="" className="feature-checkbox" /><div className="text-l is--dimmed">Single Billing</div></div>
                <div className="feature-item"><img src="img/checkbox.svg" loading="lazy" alt="" className="feature-checkbox" /><div className="text-l is--dimmed">Premium support</div></div>
              </div>
              <div className="features__cta">
                <a
                  href="#pricing"
                  className="button is--indigo w-inline-block"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '14px 28px',
                    background: 'linear-gradient(90deg, #fdd106 0%, #efc504 100%)',
                    color: '#fff',
                    borderRadius: '10px',
                    fontWeight: 700,
                    fontSize: '18px',
                    boxShadow: '0 6px 18px rgba(74,144,226,0.15)',
                    border: 'none',
                    transition: 'all 0.3s',
                    letterSpacing: '0.5px',
                    textDecoration: 'none',
                    marginTop: '16px',
                  }}
                  onMouseOver={e => e.currentTarget.style.background = 'linear-gradient(90deg, #357abd 0%, #4a90e2 100%)'}
                  onMouseOut={e => e.currentTarget.style.background = 'linear-gradient(90deg, #4a90e2 0%, #357abd 100%)'}
                >
                  <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '4px'}}>
                    <circle cx="11" cy="11" r="11" fill="#fff" fillOpacity="0.15"/>
                    <path d="M7 11.5l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <div>Sign up</div>
                </a>
              </div>
            </div>
          </div>
          <div className="features is--rev" >
            <div className="features__item">
              <div className="features__item-bg is--yellow"></div>
              <div className="features__image-container">
                <img src="img/banner3.png" loading="lazy" sizes="(max-width: 767px) 45vw, (max-width: 991px) 26vw, (max-width: 1439px) 22vw, (max-width: 1919px) 19vw, 319.4375px" srcSet="img/banner3-500.png 500w, img/banner3-800.png 800w, img/banner3-1080.png 1080w, img/banner3.png 1212w" alt="" className="features__image" />
              </div>
            </div>
            <div className="features__item is--text is--two">
              <div className="features__title">
                <h2 className="h2-2" style={{ fontSize: '38px' }}>Teams</h2>
                <div className="plan-badge is--ace">
                  <div>Ace</div>
                </div>
                
              </div>
              <div className="features-list">
                <div className="feature-item"><img src="img/checkbox.svg" loading="lazy" alt="" className="feature-checkbox" /><div className="text-l is--dimmed">All Features of Teams Premium </div></div>
                <div className="feature-item"><img src="img/checkbox.svg" loading="lazy" alt="" className="feature-checkbox" /><div className="text-l is--dimmed">Customized Rates</div></div>
                <div className="feature-item"><img src="img/checkbox.svg" loading="lazy" alt="" className="feature-checkbox" /><div className="text-l is--dimmed">Dedicated support team</div></div>
              </div>
              <div className="features__cta">
                <a
                  href="#pricing"
                  className="button is--indigo w-inline-block"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '14px 28px',
                    background: 'linear-gradient(90deg, #fdd106 0%, #efc504 100%)',
                    color: '#fff',
                    borderRadius: '10px',
                    fontWeight: 700,
                    fontSize: '18px',
                    boxShadow: '0 6px 18px rgba(74,144,226,0.15)',
                    border: 'none',
                    transition: 'all 0.3s',
                    letterSpacing: '0.5px',
                    textDecoration: 'none',
                    marginTop: '16px',
                  }}
                  onMouseOver={e => e.currentTarget.style.background = 'linear-gradient(90deg, #357abd 0%, #4a90e2 100%)'}
                  onMouseOut={e => e.currentTarget.style.background = 'linear-gradient(90deg, #4a90e2 0%, #357abd 100%)'}
                >
                  <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '4px'}}>
                    <circle cx="11" cy="11" r="11" fill="#fff" fillOpacity="0.15"/>
                    <path d="M7 11.5l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <div>Sign up</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="pricing" className="section is--pricing" style={{ padding: '15px 0' }}>
        <div className="container-2" style={{ padding: '0 20px' }}>
          <div className="section-header is--pricing" style={{ marginBottom: '12px' }}>
            <h4 className="h2-2 is--no-paragraph" style={{ marginBottom: '8px' }}>Pricing</h4>
            <h3 className="h2-2 is--no-paragraph">Choose your plan</h3>
          </div>
        </div>
        <div className="container-2 is--pricing" style={{ padding: '0 20px' }}>
          <TeamPart />
        </div>
      </div>
      <FeaturesFooter />
      <Footer />
    </div>
  );
};

export default Teams; 